import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';

import CustomRouter from './utils/CustomRouter';
import MinimizedWidget from './components/views/LayoutElectron/MinimizedWidget';
import WidgetProfile from './components/views/LayoutElectron/profile';
import WidgetNotifications from './components/views/LayoutElectron/notifications';
import WidgetLogout from './components/views/LayoutElectron/logout';
import WidgetChat from './components/views/LayoutElectron/chat';
import WidgetChatFind from './components/views/LayoutElectron/chat/find';

// Crear un customRouter

import { Layout, Login, Office, Calendar } from './components/views';
import {
  Home,
  New,
  MenuWeekly,
  Auth,
  Employee,
  Audiences,
  ChannelShareDetail
} from './components/containers';
import { StyledNewsWidget } from './components/views/LayoutElectron/home/style';
import { StyledWidgetBox } from './components/views/LayoutElectron/apps/style';
import { StyledCalendar } from './components/views/LayoutElectron/agenda/style';
import { StyledLogin } from './components/views/LayoutElectron/login/style';
import DataFormUser from './components/views/DataFormUser';

/** Assets */
import { EmailLogo } from '../assets/images';

/** Error */
import ErrorNumber from './components/views/ErrorNumber';

/* Containers */
import ProfileWrapper from './components/containers/Employee/Profile';
import PressResumePage from './components/containers/PressResume';
import GalleryPage from './components/containers/Gallery';
import DigitalAudiencePage from './components/containers/DigitalAudience';
import RadioAudiencePage from './components/containers/RadioAudience';
import RRSSAudiencePage from './components/containers/RRSSAudience';
import StrategyPage from './components/containers/Strategy';
import EmployeeDirectory from './components/containers/EmployeeDirectory';

import FoodTickets from './components/containers/Employee/FoodTickets';
import Payroll from './components/containers/Employee/Payroll';
import WithholdingFile from './components/containers/Employee/WithholdingFile';
import Withholding from './components/containers/Employee/Withholding';
import WithholdingRRHH from './components/containers/Employee/WithholdingRRHH';
import Training from './components/containers/Employee/Training';
import PayrrollIncidence from './components/containers/Employee/PayrrollIncidence';
import AccessControl from './components/containers/Employee/AccessControl';
import FiscalData from './components/containers/Employee/FiscalData';
import GeneralInformation from './components/containers/Department/GeneralInformation';
import DocumentsPage from './components/containers/Department/Documents';
import LayoutElectron from './components/views/LayoutElectron';
import OndaCeroServices from './components/containers/OndaCero';
import RentalInquiry from './components/containers/OndaCero/RentalInquiry';
import StationDirectory from './components/containers/OndaCero/StationDirectory';
import RelevantDocumentation from './components/containers/RelevantDocumentation';
import RelevantDocumentationDistributive from './components/views/RelevantDocumentation';
import ComercialOffers from './components/containers/CommercialOffers';
import MenuDocs from './components/containers/MenuDocs';
import DocsExplorer from './components/containers/DocsExplorer';
import Workflow from './components/containers/Employee/Workflow';
import NewFolder from './components/containers/Department/Documents/newFolder';
import NewFile from './components/containers/Department/Documents/newFile';

/** Constants */
import {
  RELEVANT_DOCUMENTATION_ID,
  NORMATIVE_COMPLIANCE_ID,
  CORPORATE_IMAGE_ID,
  PREVENTION_SSMM_ID,
  DATA_PROTECTION_ID
} from './constants/associationId';
import {
  RELEVANT_DOCUMENTATION_ID_PRO,
  NORMATIVE_COMPLIANCE_ID_PRO,
  CORPORATE_IMAGE_ID_PRO,
  PREVENTION_SSMM_ID_PRO,
  DATA_PROTECTION_ID_PRO
} from './constants/associationIdPro';
import InboxIncidence from './components/views/Employee/InboxIncidence';
import MyNotifications from './components/containers/MyNotifications';
import EventPlayerRoute from './components/containers/EventPlayerRoute';
import EventPlayerRoute2 from './components/containers/EventPlayerRoute2';
import RedirectActiveDirectory from './components/views/RedirectActiveDirectory';
import EventPlayerEditAtresmedia from './components/containers/EventPlayerEditAtresmedia';
import MerryChristmasComponent from './components/containers/MerryChristmasComponent';

const associationId = {
  production: {
    relevant: RELEVANT_DOCUMENTATION_ID_PRO,
    normative: NORMATIVE_COMPLIANCE_ID_PRO,
    corporate: CORPORATE_IMAGE_ID_PRO,
    prevention: PREVENTION_SSMM_ID_PRO,
    protection: DATA_PROTECTION_ID_PRO
  },
  development: {
    relevant: RELEVANT_DOCUMENTATION_ID,
    normative: NORMATIVE_COMPLIANCE_ID,
    corporate: CORPORATE_IMAGE_ID,
    prevention: PREVENTION_SSMM_ID,
    protection: DATA_PROTECTION_ID
  }
};

const errorData = {
  type: 'Error',
  number: '404',
  description: 'No hemos encontrado la página que buscas',
  actions: [
    {
      text: 'Ir a la portada',
      link: '/'
    }
  ]
};

// La ruta al login tiene que estar fuera del componente Auth porque si no el
// componente Login no se carga (porque sería parte del children del Auth)

const routes = ({ typology }) => {
  const IDassociation =
    associationId[
      process.env.NODE_ENV === 'development' ? 'development' : 'production'
    ];
  return (
    <CustomRouter>
      <Switch>
        <Route exact path="/login" render={props => <Login {...props} />} />
        <Route
          exact
          path="/login_widget"
          render={props => <StyledLogin isWidget {...props} />}
        />
        <Route path="/retencion" component={WithholdingFile} />
        <Route
          exact
          path="/register"
          render={props => <RedirectActiveDirectory {...props} />}
        />
        <Route
          render={props => (
            <Auth {...props}>
              <Switch>
                <Route
                  exact
                  path="/perfil/:id/buzondesugerencias"
                  render={props => (
                    <Employee {...props}>
                      <InboxIncidence />
                    </Employee>
                  )}
                />
                <Route
                  exact
                  path="/gestion-retenciones"
                  render={props => <WithholdingRRHH {...props} />}
                />
                <Route
                  exact
                  path="/userFormData"
                  render={props => <DataFormUser {...props} />}
                />
                <Route exact path="/" component={Home} />
                <Route
                  exact
                  path="/perfil/:id/mi_perfil"
                  render={props => (
                    <Employee {...props}>
                      <ProfileWrapper {...props} />
                    </Employee>
                  )}
                />

                {/* <Route
                  exact
                  path="/perfil/:id/editar"
                  render={() => (
                    <Fragment>
                      {/* <Prompt
                      when={editedProfile}
                      message={location =>
                        location.pathname.startsWith('/perfil/editar')
                          ? true
                          : 'Se perderán los cambio4, ¿Está seguro?'
                      }
                    />
                      <Employee {...props}>
                        <ProfileWrapper {...props} editMode />
                      </Employee>
                    </Fragment>
                  )}
                /> */}
                <Route
                  path="/perfil/:id/tickets"
                  render={props => (
                    <Employee {...props}>
                      <FoodTickets />
                    </Employee>
                  )}
                />
                <Route
                  exact
                  path="/perfil/retenciones"
                  render={props => (
                    <Employee {...props}>
                      <Withholding />
                    </Employee>
                  )}
                />
                <Route
                  exact
                  path="/perfil/:id/formacion"
                  render={props => (
                    <Employee {...props}>
                      <Training />
                    </Employee>
                  )}
                />
                <Route
                  exact
                  path="/perfil/workflow"
                  render={props => (
                    <Employee hideMenuTabs {...props}>
                      <Workflow />
                    </Employee>
                  )}
                />
                <Route
                  exact
                  path="/perfil/:id/mis_datos"
                  render={props => (
                    <Employee {...props}>
                      {typology === 'INTERNAL' ? (
                        <FiscalData />
                      ) : (
                        <DataFormUser {...props} editMode />
                      )}
                    </Employee>
                  )}
                />
                <Route
                  exact
                  path="/perfil/nominas"
                  render={props => (
                    <Employee {...props}>
                      <Payroll />
                    </Employee>
                  )}
                />
                <Route
                  exact
                  path="/perfil/:id/nomina-incidencia"
                  render={props => (
                    <Employee {...props}>
                      <PayrrollIncidence />
                    </Employee>
                  )}
                />
                <Route
                  exact
                  path="/perfil/control-acceso"
                  render={props => (
                    <Layout {...props}>
                      <AccessControl />
                    </Layout>
                  )}
                />
                <Route
                  exact
                  path="/agenda"
                  render={props => (
                    <Layout {...props}>
                      <Calendar {...props} />
                    </Layout>
                  )}
                />
                <Route
                  path="/agenda/:id"
                  render={props => (
                    <Layout {...props}>
                      <Calendar {...props} />
                    </Layout>
                  )}
                />
                <Route exact path="/office" component={Office} />
                <Route path="/noticia/:id" component={New} />
                <Route path="/somos3.0/:id" component={New} />
                <Route path="/resumen_prensa" component={PressResumePage} />
                <Route path="/gallery" component={GalleryPage} />
                <Route path="/video-event" component={EventPlayerRoute} />
                <Route path="/video-webinar" component={EventPlayerRoute2} />
                <Route
                  path="/video-edit-atresmedia"
                  component={EventPlayerEditAtresmedia}
                />
                <Route
                  path="/feliz-navidad-2025"
                  component={MerryChristmasComponent}
                />
                <Route
                  path="/audiencias_digitales"
                  component={DigitalAudiencePage}
                />
                <Route path="/audiencia_rrss" component={RRSSAudiencePage} />
                <Route path="/audiencia_radio" component={RadioAudiencePage} />
                <Route path="/strategy" component={StrategyPage} />
                <Route
                  path="/mis_notificaciones"
                  render={props => (
                    <Layout {...props}>
                      <MyNotifications {...props} />
                    </Layout>
                  )}
                />
                <Route
                  path="/directorio_empleados"
                  render={props => (
                    <Layout {...props}>
                      <EmployeeDirectory {...props} />
                    </Layout>
                  )}
                />
                <Route
                  path="/departamento/:id/informacion_general"
                  render={props => (
                    <Employee
                      {...props}
                      type="area"
                      textButtonAction="Nuestras cosas"
                    >
                      <GeneralInformation {...props} />
                    </Employee>
                  )}
                />
                <Route
                  path="/departamento/:id/documentos"
                  render={props => (
                    <Employee
                      {...props}
                      type="department"
                      textButtonAction="Nuestras cosas"
                    >
                      <DocumentsPage {...props} key={props.location.pathname} />
                    </Employee>
                  )}
                />
                <Route
                  path="/menu/semanal"
                  render={props => (
                    <Layout {...props}>
                      <MenuWeekly {...props} />
                    </Layout>
                  )}
                />
                <Route
                  exact
                  path="/audiencias"
                  render={props => (
                    <Layout {...props}>
                      <Audiences />
                    </Layout>
                  )}
                />
                <Route
                  path="/audiencias/ranking_cadenas"
                  render={props => (
                    <Layout {...props}>
                      <ChannelShareDetail />
                    </Layout>
                  )}
                />
                <Route
                  path="/widget/agenda"
                  render={props => (
                    <LayoutElectron>
                      <StyledCalendar {...props} />
                    </LayoutElectron>
                  )}
                />
                <Route
                  path="/widget/perfil"
                  render={props => (
                    <LayoutElectron>
                      <WidgetProfile {...props} />
                    </LayoutElectron>
                  )}
                />
                {/* render={() => <electron><layoutElectron><stylewidget><Calendar {...props} /></stylewidget></layoutElectron></electron>} */}
                <Route
                  path="/widget/apps"
                  render={() => (
                    <LayoutElectron>
                      <StyledWidgetBox
                        key="shortcut"
                        id={1}
                        name="accesos directos"
                        type="shortcutWidget"
                        link={null}
                        index={1}
                        isWidget
                        {...props}
                      />
                    </LayoutElectron>
                  )}
                />
                <Route
                  path="/widget/noticias"
                  render={props => (
                    <LayoutElectron {...props}>
                      <StyledNewsWidget />
                    </LayoutElectron>
                  )}
                />
                <Route
                  path="/widget/notificaciones"
                  render={props => (
                    <LayoutElectron {...props}>
                      <WidgetNotifications />
                    </LayoutElectron>
                  )}
                />
                <Route
                  path="/widget/logout"
                  render={props => (
                    <LayoutElectron {...props}>
                      <WidgetLogout />
                    </LayoutElectron>
                  )}
                />
                <Route
                  path="/widget/chat"
                  exact
                  render={props => (
                    <LayoutElectron {...props}>
                      <WidgetChat />
                    </LayoutElectron>
                  )}
                />
                <Route
                  path="/widget/chat/find"
                  exact
                  render={props => (
                    <LayoutElectron {...props}>
                      <WidgetChatFind />
                    </LayoutElectron>
                  )}
                />
                <Route
                  path="/widget/mini"
                  render={props => <MinimizedWidget {...props} />}
                />
                <Route
                  path="/email_logo"
                  render={() => <img src={EmailLogo} alt="email_logo" />}
                />
                <Route
                  path="/servicios-onda-cero/"
                  render={props => (
                    <Layout {...props}>
                      <OndaCeroServices {...props} />
                    </Layout>
                  )}
                />
                <Route
                  path="/consulta-alquileres"
                  render={props => (
                    <Layout {...props}>
                      <RentalInquiry {...props} />
                    </Layout>
                  )}
                />
                <Route
                  path="/consulta-emisoras"
                  render={props => (
                    <Layout {...props}>
                      <StationDirectory {...props} />
                    </Layout>
                  )}
                />
                <Route
                  path="/documentacion-relevante"
                  render={props => (
                    <Layout {...props}>
                      <RelevantDocumentationDistributive {...props} />
                    </Layout>
                  )}
                />
                <Route
                  path="/cumplimiento-normativo"
                  render={props => (
                    <Layout {...props}>
                      <RelevantDocumentation
                        title="Cumplimiento normativo"
                        associationId={IDassociation.normative}
                        {...props}
                      />
                    </Layout>
                  )}
                />
                <Route
                  path="/imagen-corporativa"
                  render={props => (
                    <Layout {...props}>
                      <RelevantDocumentation
                        title="Imagen corporativa"
                        associationId={IDassociation.corporate}
                        {...props}
                      />
                    </Layout>
                  )}
                />
                <Route
                  path="/prevencion-y-ssmm"
                  render={props => (
                    <Layout {...props}>
                      <RelevantDocumentation
                        title="Prevención y SSMM"
                        associationId={IDassociation.prevention}
                        {...props}
                      />
                    </Layout>
                  )}
                />
                <Route
                  path="/proteccion-de-datos"
                  render={props => (
                    <Layout {...props}>
                      <RelevantDocumentation
                        title="Protección de datos"
                        associationId={IDassociation.protection}
                        {...props}
                      />
                    </Layout>
                  )}
                />
                <Route
                  path="/ofertas-comerciales"
                  render={props => (
                    <Layout {...props}>
                      <ComercialOffers {...props} />
                    </Layout>
                  )}
                />
                <Route
                  path="/documentos-intranet/:department"
                  render={props => (
                    <Layout {...props}>
                      <DocsExplorer {...props} />
                    </Layout>
                  )}
                />
                <Route
                  path="/documentos-intranet"
                  render={props => (
                    <Layout {...props}>
                      <MenuDocs {...props} />
                    </Layout>
                  )}
                />
                <Route
                  path="/newFolder/:parentFolderId"
                  render={props => (
                    <Layout {...props}>
                      <NewFolder {...props} />
                    </Layout>
                  )}
                />
                <Route
                  path="/newFile/:parentFolderId"
                  render={props => (
                    <Layout {...props}>
                      <NewFile {...props} />
                    </Layout>
                  )}
                />
                <Route
                  render={() => (
                    <Layout {...props}>
                      <ErrorNumber data={errorData} />
                    </Layout>
                  )}
                />
              </Switch>
            </Auth>
          )}
        />
      </Switch>
    </CustomRouter>
  );
};
routes.propTypes = {
  editedProfile: PropTypes.bool,
  typology: PropTypes.oneOf(['INTERNAL', 'EXTERNAL'])
};

routes.defaultProps = {
  editedProfile: false,
  typology: 'EXTERNAL'
};

const mapStateToProps = state => ({
  editedProfile: state.user.editedProfile,
  typology: state.user.user.typology
});

export default connect(mapStateToProps, null)(routes);
